import React from "react";
import { Modal, Paper } from "@mui/material";
import styled from "styled-components";
import TeamInvitedCard from "src/scenes/teams/team/team-invited-card";

const ModalContainer = styled(Paper)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const TeamMemberInviteModal = ({ open, handleClose, selectedMember, team }) => {
    if (!selectedMember || !team || !team.members) return null;

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="team-member-modal-title"
            aria-describedby="team-member-modal-description"
        >
            <ModalContainer>
                <TeamInvitedCard
                    invite={selectedMember}
                    onClick={() => {}}
                    expanded
                    onModalClose={handleClose}
                />
            </ModalContainer>
        </Modal>
    );
};

export default TeamMemberInviteModal;
